import React, {useEffect, useRef} from 'react';
import {withRouter} from 'react-router';

import useReportRoute, {ContextType, LocationProps, ParamProps} from './useReportRoute';

export const ReportsContext = React.createContext<ContextType>(undefined!); // fix

interface Props {
  children: React.ReactNode;
  location: LocationProps;
  params: ParamProps;
}

function ReportsProvider({
  children,
  location = {
    query: {},
    pathname: ''
  },
  params = {}
}: Props) {
  const context = useReportRoute({location, params});
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      return;
    }
    didMountRef.current = true;
  }, []);

  if (!didMountRef.current) {
    return null;
  }

  return <ReportsContext.Provider value={context}>{children}</ReportsContext.Provider>;
}

export default withRouter(ReportsProvider);
